import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export type StepState = 'done' | 'active' | 'pending';

export const StepProgressRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
}));

export const StepItem = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 80,
});

export const StepDot = styled('div', {
  shouldForwardProp: prop => prop !== '$state',
})<{ $state: StepState }>(({ theme, $state }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: $state === 'pending' ? theme.palette.grey[300] : theme.palette.primary.main,
  color: $state === 'pending' ? theme.palette.grey[600] : theme.palette.common.white,
  fontSize: 12,
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(1),
}));

export const StepLabel = styled(Typography, {
  shouldForwardProp: prop => prop !== '$state',
})<{ $state: StepState }>(({ theme, $state }) => ({
  textAlign: 'center',
  color: $state === 'pending' ? theme.palette.grey[500] : theme.palette.primary.main,
  fontWeight: $state === 'active' ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular,
}));

export const StepConnector = styled('div', {
  shouldForwardProp: prop => prop !== '$filled',
})<{ $filled: boolean }>(({ theme, $filled }) => ({
  flex: 1,
  height: 2,
  backgroundColor: $filled ? theme.palette.primary.main : theme.palette.grey[300],
  margin: theme.spacing(-3, 1, 0),
}));
